/* eslint-disable no-alert */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'

import { Segment, Grid, Table, Button, Tab, Label } from 'semantic-ui-react'

import firebase from '../../config/firebase'

import DateFields from './component/DateFields'
import Loading from '../../components/common/loading'
import DownloadButton from './component/Download'

import utils from '../../utils'

import MerchantSettlementActions from '../../reducers/merchantSettlementReducer'

class MerchantSettlement extends Component {
  state = {
    startFrom: moment().format('YYYY-MM-DD'),
    endAt: moment().format('YYYY-MM-DD'),
  }

  componentDidMount() {
    const { loaded, syncMerchantSettlements } = this.props

    if (!loaded) {
      syncMerchantSettlements()
    }
  }

  onView = merchantSettlementId => {
    const { history } = this.props

    history.push({
      pathname: `/merchant-settlements/detail/${merchantSettlementId}`,
    })
  }

  onSearch = () => {
    const { startFrom, endAt } = this.state
    const { getPayLaterOrders, merchantSettlements } = this.props

    const latestSettlement = merchantSettlements.slice(-1)[0]
    const latestSettlementDate = latestSettlement && Number(latestSettlement.end_at)

    const isValidStartFrom = moment(startFrom).isAfter(moment(latestSettlementDate))

    if (latestSettlement && !isValidStartFrom) {
      alert('Search already settled')
      return
    }

    if (!moment(startFrom).isBefore(moment(endAt))) {
      alert('End Date can not be greater than Start Date')
      return
    }

    if (!moment(endAt).isBefore(moment())) {
      alert('End Date can not be greater or equal to today')
      return
    }

    getPayLaterOrders(startFrom, endAt)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  renderTableRestaurantRow = () => {
    const { restaurants } = this.props

    if (_.size(restaurants) > 0) {
      const branchRows = []
      let i = 0
      _.map(restaurants, restaurant => {
        const branches = _.map(restaurant.branches, branch => {
          i += 1
          return (
            <Table.Row key={branch.key}>
              <Table.Cell>{i}</Table.Cell>
              <Table.Cell>
                {restaurant.name} - {branch.name}
              </Table.Cell>
              <Table.Cell>{branch.aba_account_name}</Table.Cell>
              <Table.Cell>{branch.aba_account_number}</Table.Cell>
              <Table.Cell textAlign="center">{branch.order_count}</Table.Cell>
              <Table.Cell textAlign="center">
                $ {Number(parseFloat(branch.total_amount).toFixed(2))}
              </Table.Cell>
            </Table.Row>
          )
        })
        branchRows.push(branches)
      })
      return branchRows
    }

    return (
      <Table.Row>
        <Table.Cell textAlign="center" colSpan={6}>
          No results
        </Table.Cell>
      </Table.Row>
    )
  }

  handleSave = () => {
    const { startFrom, endAt } = this.state
    const { saveMerchantSettlement, restaurants, history } = this.props
    const { id } = firebase
      .firestore()
      .collection('merchant_settlements')
      .doc()

    saveMerchantSettlement(id, restaurants, startFrom, endAt, () => {
      history.push({
        pathname: `/merchant-settlements/detail/${id}`,
      })
    })
  }

  renderMerchantSettlementRow = () => {
    const { merchantSettlements } = this.props

    if (merchantSettlements.length > 0) {
      return merchantSettlements.map((settlement, index) => {
        const startAt = moment(Number(settlement.start_at)).format('DD-MMM-YYYY')
        const endAt = moment(Number(settlement.end_at)).format('DD-MMM-YYYY')

        let branchCount = 0
        let paidBranchCount = 0

        Object.values(settlement.restaurants).forEach(({ branches }) => {
          Object.values(branches).forEach(branch => {
            branchCount += 1

            if (branch.status === 'paid') paidBranchCount += 1
          })
        })

        return (
          <Table.Row key={settlement.id}>
            <Table.Cell>{index + 1}</Table.Cell>
            <Table.Cell textAlign="center">{startAt}</Table.Cell>
            <Table.Cell textAlign="center">{endAt}</Table.Cell>
            <Table.Cell textAlign="center">
              {paidBranchCount === branchCount && <Label color="green">Cleared</Label>}
              <Button size="mini" onClick={() => this.onView(settlement.id)}>
                View
              </Button>
              <DownloadButton
                merchantSettlementId={settlement.id}
                filename={`merchant-settlement-${startAt}-${endAt}`}
              />
            </Table.Cell>
          </Table.Row>
        )
      })
    }

    return (
      <Table.Row>
        <Table.Cell textAlign="center" colSpan={6}>
          No results
        </Table.Cell>
      </Table.Row>
    )
  }

  renderHistory = () => {
    return (
      <Tab.Pane color="black" attached={false}>
        <Segment>
          <Table basic="very">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>No</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Start At</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">End At</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Action</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderMerchantSettlementRow()}</Table.Body>
          </Table>
        </Segment>
      </Tab.Pane>
    )
  }

  renderMerchantSettlements = () => {
    const { startFrom, endAt } = this.state
    const { loading, saving, restaurants } = this.props
    const disabled = !saving && !loading && !(_.size(restaurants) > 0)

    return (
      <Tab.Pane color="black" attached={false}>
        <Segment>
          <DateFields
            startFrom={startFrom}
            endAt={endAt}
            loading={loading}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />
          <Table basic="very">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>No</Table.HeaderCell>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>ABA Name</Table.HeaderCell>
                <Table.HeaderCell>ABA Number</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Orders</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Amount</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderTableRestaurantRow()}</Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="6">
                  <Button
                    floated="right"
                    color="black"
                    onClick={this.handleSave}
                    loading={saving}
                    disabled={disabled}
                  >
                    Save
                  </Button>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </Segment>
      </Tab.Pane>
    )
  }

  onTabChange = index => {
    const { history } = this.props
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/merchant-settlements${queryString}`)
  }

  tabPanes = () => ({
    'merchant-settlements': {
      menuItem: 'Merchant Settlements', render: this.renderMerchantSettlements
    },
    'history': {
      menuItem: 'History', render: this.renderHistory
    },
  })

  render() {
    const { loading } = this.props
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'merchant-settlements'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <div>
        <Loading active={loading} />
        <Grid columns="equal">
          <Grid.Column grid={16}>
            <Tab
              activeIndex={tabIndex}
              menu={{ pointing: true }}
              panes={Object.values(this.tabPanes())}
              onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
            />
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ merchantSettlements }) => ({
  loaded: merchantSettlements.loaded,
  loading: merchantSettlements.loading,
  saving: merchantSettlements.saving,
  merchantSettlements: Object.values(merchantSettlements.data),
  restaurants: merchantSettlements.restaurants,
})

const mapDispatch = {
  getPayLaterOrders: MerchantSettlementActions.fetchPayLaterOrders,
  saveMerchantSettlement: MerchantSettlementActions.saveMerchantSettlement,
  syncMerchantSettlements: MerchantSettlementActions.syncMerchantSettlements,
}

export default connect(
  mapState,
  mapDispatch
)(MerchantSettlement)



// WEBPACK FOOTER //
// ./src/containers/merchantSettlement/index.js